import { Alert, Box, Button } from '@mui/material'
import { getAxiosErrorMessage } from 'api/axios/helpers'
import type { AxiosError } from 'axios'
import { CoreMyntModal } from 'components/modals/CoreMyntModal'
import { useGetCountryGroupTranslations, useUpdateCountryGroupTranslations } from './adapters'
import { TranslationsTab } from './TranslationsTab'
import { useTranslationsFields } from './useTranslationsFields'

export const EditCountryGroupTranslationsModal = ({
  open,
  onClose,
  countryGroupId,
  countryGroupName,
}: {
  open: boolean
  onClose: () => void
  countryGroupId: string
  countryGroupName: string
}) => {
  const { data: loadedTranslations } = useGetCountryGroupTranslations({ countryGroupId })
  const {
    translationFields,
    updateTranslation,
    markBlurred,
    buildPatchPayload,
    translationsValidationErrors,
    hasTranslationsValidationErrors,
    isTranslationsChanged,
  } = useTranslationsFields(loadedTranslations, { requireDescription: false })

  const { mutate: mutateTranslations, isLoading: transLoading, error: transError } = useUpdateCountryGroupTranslations()

  const handleSave = () => {
    const patchPayload = buildPatchPayload()
    if (patchPayload.length > 0) {
      mutateTranslations({ id: countryGroupId, translations: patchPayload }, { onSuccess: onClose })
    }
  }

  return (
    <CoreMyntModal
      wrapperProps={{ style: { minWidth: 600 } }}
      title={`${countryGroupName} translations`}
      onClose={onClose}
      open={open}
      actions={() => (
        <Button
          variant="contained"
          disabled={!isTranslationsChanged || hasTranslationsValidationErrors || transLoading}
          onClick={handleSave}
        >
          {transLoading ? 'Saving...' : 'Save translations'}
        </Button>
      )}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {transError instanceof Error && (
          <Alert severity="error">
            {(transError as AxiosError).response ? getAxiosErrorMessage(transError as AxiosError) : transError.message}
          </Alert>
        )}
        <TranslationsTab
          currentName={countryGroupName}
          translationFields={translationFields}
          translationsValidationErrors={translationsValidationErrors}
          onUpdate={updateTranslation}
          onBlur={markBlurred}
          showDescription={false}
        />
      </Box>
    </CoreMyntModal>
  )
}
